import { Button, Popconfirm, Space, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import Table from "../../../shared/components/ui/Table";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { listCustomerGroupsService } from "../../../shared/services";
import { DataListCustomerGroups } from "../../../redux/@types/listCustomerGroups";
import { useListCustomerGroups, useTableListCustomerGroups } from "../hooks";

export const TableListCustomerGroups = () => {
  const { removeListCustomerGroup, changeListCustomerGroupsForUpdate } =
    useTableListCustomerGroups();
  const { setTableProps } = useListCustomerGroups();

  const columns: TableColumns<DataListCustomerGroups> = [
    {
      title: "ID",
      width: 80,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Nombre",
      key: "name",
      dataIndex: "name",
      filterType: "text",
      render: (name: string) => <strong>{name}</strong>,
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 120,
      render: (_, item) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="text"
              icon={<EditOutlined />}
              onClick={() => changeListCustomerGroupsForUpdate(item)}
            />
          </Tooltip>
          <Popconfirm
            title="¿Eliminar este grupo?"
            description={`Se eliminará "${item.name}". Esta acción no se puede deshacer.`}
            okText="Eliminar"
            cancelText="Cancelar"
            okButtonProps={{ danger: true }}
            onConfirm={() => removeListCustomerGroup(item.id)}
          >
            <Tooltip title="Eliminar">
              <Button type="text" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table<DataListCustomerGroups>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      scroll={{ x: "max-content" }}
      service={listCustomerGroupsService}
      onLoad={setTableProps}
    />
  );
};
